export default `
<h3 style="text-align: justify;"><b>Profundización del capitalismo.</b></h3>
<p style="text-align: justify;"><span lang="es-AR">Entre 1880 y 1914,
una segunda etapa de industrialización, más pronunciada que la primera,
alcanzó a los países europeos y transformó sus estructuras económicas,
sociales y políticas. El mercado mundial comenzó a influir en forma
decisiva en aquellos que, a partir de los progresos técnicos, tuvieron
que adaptar sus métodos tradicionales de trabajo. En Estados
proveedores de materias primas como los latinoamericanos, la demanda
sostenida y la gran cantidad de inversiones extranjeras modificaron la
economía, la infraestructura de transporte, la producción y la sociedad.</span></p>
<p style="text-align: justify;"><span lang="es-AR">Durante estos años,
la Argentina experimentó el periodo de desarrollo más rápido y sólido
de su historia. Esta profundización del capitalismo mundial la colocó
entre las primeras naciones del mundo por su ingreso per cápita y por
otros indicadores vinculados a la calidad de vida de sus habitantes. La
población creció con rapidez gracias al ingreso de inmigrantes y las
ciudades se expandieron. Junto con este crecimiento de la población se
formó un importante mercado interno, que estuvo acompañado de un
incipiente desarrollo industrial para satisfacerlo.</span></p>
<h3 style="text-align: justify;"><b>Crecimiento del mercado interno y
de la industria.</b></h3>
<p style="text-align: justify;"><span style="font-weight: 400;"><img
style="width: 304px; height: 388px;"
class="size-full wp-image-199 alignleft"
src="https://consumoenargentina.files.wordpress.com/2018/09/consumoconceptos-1.jpg"
alt="consumoconceptos" align="left" hspace="5"></span></p>
<p class="western" style="text-align: justify;">Por efecto de la
inmigración masiva, la población de Argentina se triplicó
mientras&nbsp; que se volvió dos veces y medio más rica. Arrastrado por
estos dos factores -más gente pudiendo comprar más cosas-, se creó un
mercado interno cuyo crecimiento fue excepcional, alcanzando el primer
lugar en América Latina y multiplicándose nueve veces de 1880 a 1914.
Para suplir este mercado interno se desarrolló un número pequeño de
industrias, casi todas ubicadas en Buenos Aires, que fue creciendo con
el tiempo, impulsado por la demanda que una población en crecimiento
hacía de productos elaborados, entre ellos podemos mencionar vino,
fósforos, zapatos, galletas, muebles, clavos, alpargatas, tornillos,
cacerolas, dulces, alfileres, velas, cerveza, cigarrillos y ropa.</p>
<p class="western" style="text-align: justify;">La demanda era
motorizada sobre todo por un sector de población de estrato medio que,
disponiendo de ingresos gracias a la próspera situación económica,
buscaba diferenciarse de los grupos más bajos emulando las pautas de
consumo de la clase alta, que observaba esto con inquietud. Esta
actitud fue captada por el sociólogo Thorstein Veblen, quien la
denominó “consumo conspicuo”.</p>
<p class="western" style="text-align: justify;">Por primera vez un gran
número de gente tenía la oportunidad de consumir, buscando
diferenciarse y de demostrar su posición social, originándose un
fenómeno que se producía a la vez en otros países que atravesaban una
coyuntura parecida, la creación de una sociedad de consumo</p>
<p class="western" style="text-align: justify;">Vemos así cómo el
surgimiento de una demanda considerable actuaba de incentivo para la
apertura de una fábrica, aunque también hubo casos en los que fue a la
inversa, es decir, los industriales se encargaron de generar la demanda
lanzándose a la producción en gran escala y con bajo precio de productos<!-- Esa es la idea? Suprimí el final porque no era claro, pero no sé si estoy cambiando lo que querías decir -->.
Para esto echaron mano de un recurso novedoso del momento: <strong>la
publicidad.⇓⇓</strong></p>
<h3 style="text-align: justify;"><b>Publicidad: El productor encuentra
al consumidor</b></h3>
<p style="text-align: justify;"><span lang="es-AR">Ante la ampliación
del mercado consumidor y el consiguiente crecimiento de la oferta de
bienes, las firmas productoras aplicaron una estrategia que buscaba
establecer una relación directa y amigable con sus clientes,
mostrándoles la posibilidad de mejorar sus vidas mediante la
adquisición de ciertos bienes. El objetivo verdadero era eliminar el
papel de intermediario que ejercía el comerciante o dueño de tiendas,
es decir, el cliente debía llegar al local con la decisión tomada
acerca de qué producto comprar. Se buscaba que el consumidor pareciera
activamente involucrado en la toma de decisiones, por eso se comenzó a
hablar de “soberanía del consumidor”. El medio utilizado para este fin
fue la publicidad y la bandera de batalla de los productos fue la marca.</span></p>
<p style="text-align: justify;"><span lang="es-AR">La publicidad
evolucionó por estos años de los aburridos avisos clasificados a un
diseño más enfocado en los elementos visuales. Esto dio forma a otros
más llamativos publicados en las revistas de la época, siendo la más
conocida “Caras y Caretas”. Con el fin de cautivar consumidores, las
publicidades usaban imágenes mostrando a la mujer moderna que ahorraba
esfuerzos remozando viejas tareas. También aparecieron los avisos
publicitarios en los frentes de las tiendas y en lugares transitados,
iluminados con colores.</span></p>
<h3 style="text-align: justify;"><b>Grandes Tiendas:</b></h3>
<p class="western" style="text-align: justify;">El&nbsp;<span
lang="es-AR">gran crecimiento económico y la aparición de un mercado
de consumo masivo con prácticas muy similares a las de los países del
hemisferio norte, atrajo a Buenos Aires a las grandes tiendas
internacionales. En 1914 la tienda londinense Harrods abrió su primera
sucursal fuera del Reino Unido. Ésta se ubicó en la calle Florida, una
de las arterias principales de la ciudad y destacado espacio de
sociabilidad para las clases privilegiadas. Junto a Harrods aparecieron
otras tiendas como Gath &amp; Chavez y Le bon Marché, que se
convirtieron en referentes de la moda y los nuevos hábitos de consumo.
Instaladas en edificios imponentes, con potente iluminación y música
ambiental, la mercadería se distribuía en varios pisos donde la gente
además de comprar, paseaba y socializaba. También se disponía de
sectores como manicuría, peluquería y lustrado de calzado. Estas
tiendas introdujeron escaparates y vidrieras preparados por
profesionales, hacia ellos se dirigía la gente para observar y decidir
cuál mercadería adquirir. Esto representó un cambio significativo de
hábitos, ya que hasta ese punto, el consumidor se dirigía a los
negocios con la decisión tomada acerca del artículo a comprar. Las
tiendas, con sus vidrieras y escaparates, intentaban seducir a los
transeúntes y a los clientes para que adquirieran cosas que éstos no
tenían en mente o que, por lo menos, no habían decidido hasta ese
momento. Se transformaron así en “paseos de compras” donde se
sociabilizaba y se consumía al mismo tiempo.</span></p>
<p style="text-align: justify;"><b style="color: rgb(0, 51, 102);"><span
style="color: rgb(128, 0, 0);">Caso Bagley</span></b><span
style="font-weight: 400; color: rgb(128, 0, 0);">:</span></p>
<p style="text-align: justify;"><span style="color: rgb(128, 0, 0);">La
primera campaña publicitaria Argentina fue realizada en 1864 por la
empresa Bagley, creada por el joven norteamericano Melville Sewell
Bagley, quien recién llegaba al país trayendo algunos conocimientos en
la elaboración de bebidas y también novedosas ideas basadas en los
métodos publicitarios norteamericanos del momento.</span></p>
<p class="western" style="text-align: justify;"><span
style="color: rgb(128, 0, 0);">Esta firma se las arregló para mantener
en vilo a la población a través de lo que para la época eran ingeniosos
anuncios que decían simplemente: “Se viene la Hesperidina”. La
expectativa fue creciendo con el paso del tiempo, la gente se
preguntaba qué era la Hesperidina, para que servía. El misterio
finalmente se develó veinticuatro horas antes de la navidad de 1864,
momento en el cual se rompió el silencio y apareció un aviso vertical
en el diario “La Tribuna” que comunicaba las bondades del producto y
los lugares donde se podía conseguir. La Hesperidina, que era un licor
preparado a base de cáscaras de naranjas, contenía propiedades para
mejorar la digestión y encontró una rápida aceptación entre los
consumidores, gracias a la influencia de la publicidad.</span></p>
<p><span style="font-weight: 400;"><img
class="alignnone size-full wp-image-177"
src="https://consumoenargentina.files.wordpress.com/2018/09/biblio-131.png"
alt="biblio-131" height="363" width="794"></span></p>
`